import { usePage } from "@inertiajs/react";

import LegalPage from "../_kit/LegalPage";
import {
  useLandingLanguage,
  LandingLanguageProvider,
} from "../../../contexts/landing-language";

const TermsOfServiceContent = () => {
  const { terms_of_service: termsOfService } = usePage().props;
  const { t } = useLandingLanguage();

  return <LegalPage document={termsOfService} fallback={t.termsOfService} />;
};

const TermsOfService = () => (
  <LandingLanguageProvider>
    <TermsOfServiceContent />
  </LandingLanguageProvider>
);

export default TermsOfService;
